import { track } from "@/lib/analytics";
import { APP_STORE_URL, IOS_APP } from "@/lib/app-store";
import { cn } from "@/lib/utils";

const BADGE_ASPECT = 119.66 / 40;

type AppStoreLinkProps = {
  cta: string;
  className?: string;
  height?: number;
};

const AppStoreLink = ({ cta, className, height = 48 }: AppStoreLinkProps) => (
  <a
    href={APP_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => track("cta_clicked", { cta, href: APP_STORE_URL })}
    aria-label={`Download ${IOS_APP.name} on the App Store`}
    className={cn("inline-flex shrink-0 transition-opacity hover:opacity-85", className)}
  >
    <img
      src={IOS_APP.badge}
      alt="Download on the App Store"
      width={Math.round(height * BADGE_ASPECT)}
      height={height}
      draggable={false}
      className="select-none"
      style={{ height, width: "auto" }}
    />
  </a>
);

export default AppStoreLink;
